<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title font-weight-normal">
        {{ $t("Advance FnB Online Booking Report") }}
      </div>
      <small><em>{{ $t("* As Per show Date") }}</em></small>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-5 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="true"
                :showLabels="false"
                :multiple="true"
                :limit="2"
                :limit-text="(count) => `& +${count} More`"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-4 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                  @selected = "onChangeDate($event, 'from')"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("from") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="toDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }}  -->
                  {{ $t("to") }}</label
                >
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getAdvanceFnBReport('N', 'N')"
            >
              {{ $t("fetch") }}
            </button>
          </div>

          <div
            v-if="advanceFnBReports.length > 0"
            class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
          >
            <div class="mx-1">{{ $t("download") }} as:</div>
            <!-- s -->

            <a style="cursor: pointer"
              target="_blank"
              @click="getAdvanceFnBReport('Y', 'N')"
              title="Download as Excel"
              download
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/excel.svg"
                height="25"
                width="25"
              />
            </a>

            <a
                target="_blank"
                @click="getAdvanceFnBReport('N', 'Y')"
                title="Download as PDF"
                download
                style="cursor: pointer;"
              >
                <img
                  class="mx-1"
                  src="@/assets/img/icons/pdf.svg"
                  height="25"
                  width="25"
                />
              </a>
          </div>
        </div>
      </div>
      <div
        style="overflow-x:scroll;width: auto !important"
        ref="exportable_table"
      >
        <!-- <table class="swc-report-table" border="1">
          <thead class="bg-lightgrey font-weight-bold">
            <th>Cinema Name</th>
            <th>Transaction Number</th>
            <th>Booking Date</th>
            <th>Show Date</th>
            <th>Show Time</th>
            <th>Item Name</th>
            <th>Delivered Status</th>
            <th>Screen Name</th>
            <th>Seat Number</th>
            <th>Order Code</th>
            <th>Pickup Code</th>
            <th>Net Sales Price</th>
            <th>Customer No.</th>
            <th>Mobile No.</th>
          </thead>
          <tbody v-if="advanceFnBReports.length > 0">
            <tr
              v-for="(advanceFnBObj, advanceFnBIndex) in advanceFnBReports"
              :key="advanceFnBIndex"
            >
            <td class="text-left">{{advanceFnBObj.cinema_name}}</td>
              <td class="text-left">{{
                advanceFnBObj.t_sb_booking_code ? advanceFnBObj.t_sb_booking_code: advanceFnBObj.order_code}}</td>
             
              <td class="text-right">{{advanceFnBObj.t_booking_date_time? advanceFnBObj.t_booking_date_time: advanceFnBObj.fnb_created_at || ""}}</td>
              <td class="text-right">{{ advanceFnBObj.t_show_date || "-" }}</td>
              <td class="text-right">{{ advanceFnBObj.t_show_time || "-" }}</td>
              <td class="text-left">{{ advanceFnBObj.item_name }}</td>
              <td class="text-left">{{
                advanceFnBObj.fat_status == "Delivered" ? "Delivered" : "Not Delivered"
              }}</td>

              <td class="text-left">{{ advanceFnBObj.screen_name || "-" }}</td>
              <td class="text-left">{{ advanceFnBObj.seat_name || "-" }}</td>
              <td class="text-left">{{ advanceFnBObj.order_code || "-" }}</td>
              <td class="text-left">{{ advanceFnBObj.pickup_code || "-" }}</td>

              <td class="text-right">{{
                currFormat(advanceFnBObj.net_sales_price)
              }}</td>

              <td class="text-left">{{
                advanceFnBObj.customer_name || "-"
              }}</td>
              <td class="text-right">{{
                advanceFnBObj.mobile_number || "-"
              }}</td>
            </tr>
            <tr
              v-if="Object.keys(grandTotal).length"
              class="bg-lightgrey font-weight-bold"
            >
              <td class="text-left" colspan="11">Grand Total</td>
              <td class="text-right">{{
                currFormat(grandTotal.total_net_sales)
              }}</td>
              <td class="text-right"></td>
              <td class="text-right"></td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="11">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table> -->

        <div v-for="(records, cinemaName) in groupedData" :key="cinemaName" class="mb-3">
  <h5>{{ cinemaName }}</h5>
  <div style="overflow-x:scroll;width: auto !important">
    <table class="swc-report-table" border="1">
      <thead class="font-weight-bold">
        <th>Transaction Id</th>
        <th>Booking Date</th>
        <th>Show Date</th>
        <th>Show Time</th>
        <th style="width: 200px;">Item Name</th>
        <th>Quantity</th>
        <th>Status</th>
        <th>Screen</th>
        <th>Seats</th>
        <th>Order Code</th>
        <th>Pickup Code</th>
        <th>Gross Sales</th>
        <th>Customer Name</th>
        <th>Mobile No.</th>
      </thead>
      <tbody>
        <tr v-for="(advanceFnBObj, idx) in records" :key="idx">
          <td class="text-left">{{ advanceFnBObj.t_sb_booking_code || advanceFnBObj.order_code }}</td>
          <td class="text-right">{{ advanceFnBObj.t_booking_date_time || advanceFnBObj.fnb_created_at || "" }}</td>
          <td class="text-right">{{ advanceFnBObj.t_show_date || "-" }}</td>
          <td class="text-right">{{ advanceFnBObj.t_show_time || "-" }}</td>
          <td class="text-left" style="width: 150px;">{{ advanceFnBObj.item_name }}</td>
          <td class="text-right">{{ advanceFnBObj.item_quantity || 0 }}</td>
          <td class="text-left">{{ advanceFnBObj.fat_status == "Delivered" ? "Delivered" : "Not Delivered" }}</td>
          <td class="text-left">{{ advanceFnBObj.screen_name || "-" }}</td>
          <td class="text-left">{{ advanceFnBObj.seat_name || "-" }}</td>
          <td class="text-left">{{ advanceFnBObj.order_code || "-" }}</td>
          <td class="text-right">{{ advanceFnBObj.pickup_code || "-" }}</td>
          <td class="text-right">{{ currFormat(advanceFnBObj.net_sales_price) }}</td>
          <td class="text-left">{{ advanceFnBObj.customer_name || "-" }}</td>
          <td class="text-right">{{ advanceFnBObj.mobile_number || "-" }}</td>
        </tr>

        <tr>
          <td colspan="5" class="font-weight-bold text-left">Total </td>
          <td class="font-weight-bold text-right">{{records.reduce((acc, el) => acc + (el.item_quantity || 0), 0)}} </td>
          <td colspan="5"></td>
          <td class="font-weight-bold text-right">{{currFormat(records.reduce((acc, el) => acc + (el.net_sales_price || 0), 0))}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

 <div style="margin-top: 10px;"></div>

  <div class="grand-total-section text-center" v-if="advanceFnBReports.length > 0">
    <h5 class="font-weight-bold">Grand Total</h5>
    <div style="overflow-x:scroll;width: auto !important">
      <table class="swc-report-table grand-total-table" border="1">
        <thead class="font-weight-bold">
         <th>Transaction Id</th>
        <th>Booking Date</th>
        <th>Show Date</th>
        <th>Show Time</th>
        <th style="width: 200px;">Item Name</th>
        <th>Quantity</th>
        <th>Status</th>
        <th>Screen</th>
        <th>Seats</th>
        <th>Order Code</th>
        <th>Pickup Code</th>
        <th>Gross Sales</th>
        <th>Customer No.</th>
        <th>Mobile No.</th>
        </thead>
        <tbody>
         <tr>
          <td colspan="5"></td>
          <td class="text-right font-weight-bold" >{{grandTotal.total_quantity}}</td>
          <td colspan="5"></td>
          <td class="text-right font-weight-bold">{{currFormat(grandTotal.total_net_sales)}}</td>
          <td colspan="2"></td>
         </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div v-else style="overflow-x:scroll;width: auto !important">
        <table class="swc-report-table grand-total-table" border="1">
          <thead>
              <th>Transaction Id</th>
        <th>Booking Date</th>
        <th>Show Date</th>
        <th>Show Time</th>
        <th style="width: 200px;">Item Name</th>
        <th>Quantity</th>
        <th>Status</th>
        <th>Screen</th>
        <th>Seats</th>
        <th>Order Code</th>
        <th>Pickup Code</th>
        <th>Gross Sales</th>
        <th>Customer No.</th>
        <th>Mobile No.</th>
          </thead>
          <tbody>
            <tr>
              <td colspan="14" class="text-center">No Records Found</td>
            </tr>
          </tbody>
        </table>
  </div>


      </div>
    </div>
  </div>
</template>
<script>
  import { BASEURL } from "@/config/index";
  import MasterService from "@/services/MasterService";
  import NewReportService from "@/services/NewReportService";
  import moment from "moment";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  import CinemasService from "@/services/CinemasService";
  import xlsx from "json-as-xlsx";
  import VueHtml2pdf from "vue-html2pdf";
  import * as XLSX from "xlsx";

  export default {
    components: {
      NoRecords,
      VueHtml2pdf,
    },
    data() {
      return {
        BASEURL,
        isRoleID: false,
        submitted: false,
        dropDown: {
          cinemas: [],
          selectedCinema: null,
          selectedCinemaName: null,
          selectedCinemaId: "",
        },
        fromDate: new Date(),
        toDate: new Date(),
        advanceFnBReports: [],
        groupedData: {},
        excelFilePath: "",
        grandTotal: {},
      };
    },
    beforeMount() {
      let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
      const { cinema_id } = this.secureStore.get("USINFO");
      this.getCinemaList(cinema_id);
      // if (CinemaObj) {
      //   this.onSelectCinema(CinemaObj);
      // }
    },
    watch: {
      // "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
      //   if (CinemaObj) {
      //     this.onSelectCinema(CinemaObj);
      //   }
      // },
      excelFilePath(value) {
        this.excelFilePath = value;
      },
    },
    mounted() {},
    methods: {
      onChangeDate(e, type){
        if(type == 'from'){
          this.toDate = new Date(e);
          this.$forceUpdate();
        }
      },
      moment,
      ExportExcel(type, fn, dl) {
        var elt = this.$refs.exportable_table;
        var wb = XLSX.utils.table_to_book(elt, {
          sheet: RawMaterialSupplierWise,
        });
        return dl
          ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
          : XLSX.writeFile(
              wb,
              fn ||
                `RawMaterialSupplierWiseCost-${
                  this.dropDown.selectedCinemaName
                }.${type || "xlsx"}`
            );
      },
      getCinemaList: function(cinema_id) {
        MasterService.GetCinemas({cine_id: cinema_id})
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.dropDown.cinemas = data.Records;
              this.CinemasCopy = data.Records;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      onSelectCinema: function(event) {
        this.dropDown.selectedCinema = event;
        this.dropDown.selectedCinemaName = event.cine_name;
        this.dropDown.selectedCinemaId = event.cine_id;
        this.$store.dispatch("selectDropdownCinema", event);
      },
      getAdvanceFnBReport(isExcel = "N", isPdf = "N") {
        if (isExcel == "N" || isPdf == "N") {
          this.advanceFnBReports = [];
        }
        if (!this.dropDown.selectedCinema.length) {
        return this.$toasted.show("Select Cinema");
      }
        if (!this.fromDate) {
          return this.$toasted.show("Select From Date");
        }
        let loader = this.$loading.show();
        let payload = {
          // cinema_id: this.dropDown.selectedCinemaId,
          // cinema_name: this.dropDown.selectedCinemaName || "",
          // cinema_address: this.dropDown.selectedCinema.cine_address || "",
          cinema_id: this.dropDown.selectedCinema.map(cinemas => {
          return cinemas.cine_id;
        }),
        cinema_name: this.dropDown.selectedCinema.map(cinemas => {
          return cinemas.cine_name;
        }),
        cinema_address: this.dropDown.selectedCinema.map(cinemas => {
          return cinemas.cine_address;
        }),
          fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
          toDate: moment(this.toDate).format("YYYY-MM-DD"),
          isExcel,
          isPdf,
        };
        NewReportService.GetAdvanceFnBReport(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.advanceFnBReports = [...data.Records];
              this.groupedData = { ...data.groupedData };
              this.grandTotal = { ...data.grandTotal };
              if (isExcel == "Y" && data.excelPath) {
                window.open(data.excelPath, "_blank");
              }
              if (isPdf == "Y" && data.pdfPath) {
                window.open(data.pdfPath, "_blank");
              }
              this.$toasted.show(data.message);
            } else {
              this.$toasted.show(data.message);
            }
            loader.hide();
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => {
              loader.hide();
            }, 100);
          });
      },
    },
  };
</script>

<style>

  .swc-report-table {
    table-layout: auto !important;
    overflow-x: scroll !important;
    border: 1px solid gray;
     font-size: 12px;
  }
  .swc-report-table td {
    white-space: nowrap !important;
  }
  .swc-report-table th {
    white-space: nowrap !important;
    border: 1px solid gray !important;
  }
  .swc_table_header th {
    border: 1px solid gray !important;
  }
  .no_border {
    border: 0px !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/advanceFnbOnline.vue